module.exports = __webpack_public_path__ + "img/copper-diamond-fill.0b29fa80.svg";